import { render } from "./MngSettings.vue?vue&type=template&id=5da431e1&ts=true"
import script from "./MngSettings.vue?vue&type=script&lang=ts"
export * from "./MngSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__